import React from 'react';
import { Toaster } from 'sonner';
import { FileManager } from './components/FileManager/FileManager';
interface AppProps {
  filesState?: 'ready' | 'loading' | 'empty' | 'error';
  rowDensity?: 'comfortable' | 'compact';
  defaultLayout?: 'list' | 'grid';
}
export function App({
  filesState = 'ready',
  rowDensity = 'comfortable',
  defaultLayout = 'list'
}: AppProps) {
  const initialStatus = filesState === 'error' ? 'error' : filesState === 'loading' ? 'loading' : 'ready';
  return <div className="min-h-full w-full bg-[#f3f3f3] text-slate-900" data-id="element-0" data-mp="2mn5f2tci77mi">
      <main className="mx-auto w-full max-w-[1400px] px-4 py-6 lg:px-6 lg:py-8" data-id="element-1" data-mp="31b8fzobovt4g">
        <FileManager key={`${filesState}-${rowDensity}-${defaultLayout}`} initialStatus={initialStatus} emptyFiles={filesState === 'empty'} compact={rowDensity === 'compact'} defaultLayout={defaultLayout} data-id="element-2" data-mp="2wka20ve6b74d" />
      </main>
      <Toaster position="bottom-right" richColors data-id="element-3" data-mp="23ti8y6semyl9" />
    </div>;
}